import React, { forwardRef } from 'react';
import cn from 'classnames';
import BaseButton from './BaseButton';

const EnableButton = forwardRef(({ title = 'Enable', className, ...props }, ref) => {
  const btnClassName = cn('enable-button', { [className]: className });
  return (
    <BaseButton
      ref={ref}
      id='enable-button'
      responsive
      fillMode='outline'
      themeColor='success'
      className={btnClassName}
      icon='check-circle'
      title={title}
      {...props}
    />
  );
});

export default EnableButton;
